import htm from '../utils/htm';

function node({element,sel = '',content = '',events = [],nodes = [], single, classNames}){
	element = element || htm(sel,content).Node || document.createDocumentFragment();
	events.forEach( ({on,fn}) => element.addEventListener(on,fn));
    nodes.forEach( nodeData => element.appendChild(node(nodeData)));
	if(classNames !== undefined){
		element.className = classNames;		
    }
    if(single){
        let singleNode = node(single);
        element.appendChild(singleNode);
        return singleNode;
    }
	return element;
}

export default node;